<template>
  <div class="header">
    <div class="header_cont">
      <div class="header_logo" @click="handleChangeNav('/index', 0)">
        <img class="logo" src="https://oss.duodians.com/lambda/office_web/banner/logo.png" alt="">
      </div>
      <div class="header_bar">
        <ul class="navs">
          <li class="f_btn navs_link" 
            v-for="(el, ind) in navs" 
            :key="ind" 
            @click="handleChangeNav(el.url, el.index)" 
            @mouseenter="navNum = el.index"
            @mouseleave="navNum = -1"
            :class="{'f_btn_color': index === ind}"
          >
            <el-dropdown v-if="el.list && el.list.length" placement="bottom-start" trigger="hover" @command="onCommand" >
               <!-- :hide-on-click="false" -->
              <span class="el-dropdown-link f_btn">
                {{el.name}}
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(e, i) in el.list" :key="i" @click.native="handleChangeNav(e.url, el.index)" :command="e.iconActivedNum">
                  <img class="img" :src="iconActivedNum === e.iconActivedNum ? e.iconActived : e.icon" alt="">
                  <span :class="iconActivedNum === e.iconActivedNum ? 'activedText' : ''">{{e.name}}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span v-else>{{el.name}}</span>
          </li>
        </ul>
      </div>
      <div class="btn_cont">
        <!-- <div class="apply_btn" href="javascript:;" @click="goToLink('/index?id=applyUse')">申请使用</div>
        <a class="login_btn" href="javascript:;" @click="goToLink('/index?id=applyUse')">登录</a> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      index: 0,
      navs: [
      {
        name: ' 首页 ',
        url: '/index',
        index: 0,
      }, 
      {
        name: '解决方案',
        url: '',
        index: 1,
        list: [{
          name: 'EMS智慧能源管理系统',
          url: '/solution',
          icon: 'https://oss.duodians.com/lambda/office_web/header/solutionIcon.png',
          iconActived: 'https://oss.duodians.com/lambda/office_web/index/smartIcon1.png',
          iconActivedNum: 1,
        }, {
          name: '储能电池数据监测平台',
          url: '/platform',
          icon: 'https://oss.duodians.com/lambda/office_web/header/platformIcon.png',
          iconActived: 'https://oss.duodians.com/lambda/office_web/index/smartIcon3.png',
          iconActivedNum: 2,
        }, {
          name: '虚拟电厂',
          url: '/virtualPower',
          icon: 'https://oss.duodians.com/lambda/office_web/header/virtualIcon.png',
          iconActived: 'https://oss.duodians.com/lambda/office_web/index/smartIcon2.png',
          iconActivedNum: 3,
        }]
      }, 
      {
        name: '核心技术',
        url: '',
        index: 2,
        list: [
          {
          name: 'Energy AI',
          url: '/energy',
          icon: 'https://oss.duodians.com/lambda/office_web/header/energyIcon.png',
          iconActived: 'https://oss.duodians.com/lambda/office_web/header/energyIconActived.png',
          iconActivedNum: 4,
        }, 
        {
          name: 'Battery AI',
          url: '/battery',
          icon: 'https://oss.duodians.com/lambda/office_web/header/energyIcon.png',
          iconActived: 'https://oss.duodians.com/lambda/office_web/header/energyIconActived.png',
          iconActivedNum: 7,
        }, 
        {
          name: '能源大数据',
          url: '/bigData',
          icon: 'https://oss.duodians.com/lambda/office_web/header/dataIcon.png',
          iconActived: 'https://oss.duodians.com/lambda/office_web/header/dataIconActived.png',
          iconActivedNum: 5,
        }, 
        {
          name: '能源物联网',
          url: '/product',
          icon: 'https://oss.duodians.com/lambda/office_web/header/productIcon.png',
          iconActived: 'https://oss.duodians.com/lambda/office_web/header/productIconActived.png',
          iconActivedNum: 6,
        }]
      }, 
      {
        name: '关于我们',
        url: '/about',
        index: 3,
      }],
      navNum: 0,
      iconActivedNum: 0
    }
  },
  components: {},
  created() {
    if (window.location.hash.split('#')[1] === '/solution') {
      this.iconActivedNum = 1
    } else if (window.location.hash.split('#')[1] === '/platform') {
      this.iconActivedNum = 2
    } else if (window.location.hash.split('#')[1] === '/virtualPower') {
      this.iconActivedNum = 3
    } else if (window.location.hash.split('#')[1] === '/energy') {
      this.iconActivedNum = 4
    } else if (window.location.hash.split('#')[1] === '/bigData') {
      this.iconActivedNum = 5
    } else if (window.location.hash.split('#')[1] === '/product') {
      this.iconActivedNum = 6
    } else if (window.location.hash.split('#')[1] === '/battery') {
      this.iconActivedNum =7
    }

  },
  watch:{
    $route:{
      immediate:true,
      handler(){
        //地址栏发生改变，该函数会执行
        let name = window.location.hash.split('#')[1]
        if (name.indexOf('?')) {
          name = name.split('?')[0]
        }
        this.navs.forEach(el => {
          if (el.url && (el.url === name)) {
            this.index = el.index
            return
          } else {
            let arr = []
            if (el.list && el.list.length) {
              arr = el.list.filter(e => e.url === name)
              if (arr.length) {
                arr[0].actived = true
                this.index = el.index
              } else {
                el.list.forEach(e => {
                  e.actived = false
                })
              }
            }
          }
        })
      }
    }
  },
  methods: {
    handleChangeNav(url, ind, i) {
      if (ind === 0 || ind === 3) {
        this.iconActivedNum = 0
      }

      this.index = ind
      if(!url) return
      this.$router.push({ path: url }, () => {})
    },
    handleHoverNav(list) {
      console.log(list);
    },
    goToLink(url) {
      // this.$router.push({ path: url })
    },
    onCommand(i) {
      this.iconActivedNum = i
    }
  }
}
</script>
<style lang='less' scoped>
.header {
  position: relative;
  z-index: 2;
  color: #fff;
  padding: 0 30px;
  .header_cont {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 80px;
    .header_logo {
      position: relative;
      cursor: pointer;
      .logo {
        width: 100px;
        height: 40px;
      }
    }
    .header_bar {
      font-size: 20px;
      .f_btn_color:after {
        content: '';
        position: relative;
        bottom: -10px;
        display: block;
        width: 56px;
        height: 2px;
        background: #fff;
        border-radius: 2px;
      }
      .navs {
        margin-left: 127px;
        display: flex;
        .f_btn {
          font-size: 20px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          text-align: left;
          color: #fff;
          cursor: pointer;
          span{
            font-size: 20px;
            min-width: 56px;
            display: flex;
            justify-content: center;
          }
        }
        .navs_link {
          margin-right: 50px;
          position: relative;
        }
      }
      .ul {
        margin: 0;
        padding: 0;
        list-style: none;
      }
    }
    .btn_cont{
      display: flex;
      align-items: center;
      .apply_btn{
        width: 88px;
        height: 36px;
        border-radius: 25px;
        border: 2px solid transparent;
        border-image: linear-gradient(270deg, #4add69 18%, #4cddbd 58%, #3cecf0 43%, #12ee90 99%) 2 2;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #2ee6a5;
      }
      .login_btn{
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #ffffff;
        margin: 0 30px;
      }
    }
  } 
}
.el-dropdown-menu{
  padding: 30px 30px 10px;
  background-color: #232f3f!important;
  border-radius: 8px;
  border: 0;
}
/deep/ .el-dropdown-menu__item{
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  line-height: 20px;
  margin-bottom: 20px;
  padding: 0;
  .img{
    width: 16px;
    margin-right: 8px;
  }
  span{
    font-size: 16px;
  }
  .activedText{
    color:#4CDDBD;
  }
}
/deep/ .el-dropdown-menu__item:hover{
  background: transparent;
  color: #fff;
}
.el-dropdown-menu__item:last-child{
  margin-bottom: 0;
}
/deep/ .popper__arrow{
  visibility: hidden!important;
}
</style>
<style>
.el-dropdown-menu__item:hover{
  background: transparent!important;
  color: #fff!important;
}
</style>





// WEBPACK FOOTER //
// src/components/dd_header/header.vue